import { render } from "./RecursiveCategories.vue?vue&type=template&id=0f81e3ae&scoped=true"
import script from "./RecursiveCategories.vue?vue&type=script&lang=js"
export * from "./RecursiveCategories.vue?vue&type=script&lang=js"

import "./RecursiveCategories.vue?vue&type=style&index=0&id=0f81e3ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f81e3ae"]])

export default __exports__